'use client';

import type { IconMediaProps } from './types';
import { type IconResource, getMediaRessource } from '../../utils/media/getMediaRessource';
import { useIntersectionObserver } from 'hooks';
import { useEffect, useState } from 'react';

const ROOT_MARGIN_INTERSECTION = '100px';

export function IconMedia(props: IconMediaProps) {
  const {
    alt,
    icon,
    filename,
    color,
    loading = 'lazy',
    rootMarginIntersection = ROOT_MARGIN_INTERSECTION,
    ...rest
  } = props;
  const source = icon || filename;
  const { svgResource: SvgMedia, iconResource } = getMediaRessource(source as string, color);

  const [imageSrc, setImageSrc] = useState<IconResource['src'] | null>(null);

  const { ref, isIntersecting } = useIntersectionObserver<HTMLImageElement>({
    rootMargin: rootMarginIntersection
  });

  useEffect(() => {
    if (isIntersecting && iconResource) {
      setImageSrc(iconResource.src);
    }
  }, [isIntersecting, iconResource?.src]);

  const svgColor = color === 'dark' ? undefined : color;

  if (SvgMedia) {
    return <SvgMedia color={svgColor} />;
  }

  if (!iconResource) {
    return null;
  }

  return (
    <img
      className="icon-media__image"
      src={imageSrc ?? undefined}
      alt={alt}
      title={alt}
      {...rest}
      width={iconResource.width}
      height={rest.height || iconResource.height}
      loading={loading}
      ref={ref}
    />
  );
}
